import React from 'react';

const About = () => {
    return (
        <h1>
            Created for learning
        </h1>
    );
};

export default About;